import { AdministrationService } from '@/services'

// eslint-disable-next-line import/no-anonymous-default-export
export const serviceMapper = {
  admin: AdministrationService,
}
